import { pruffConnectGetReceivedInvoices } from 'lib/api/express/billing';
import GlobalSearcher, { Filter } from 'lib/common/GlobalSearcher';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import { Pagination } from 'lib/types/shared';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AuthState } from 'services/redux/authSlice';

interface Invoice {
  id: number;
  folio: string;
  amount: number;
  receiptDate: string;
  issuedDate: string;
}
const BASE_PAGINATION = {
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 0,
};

const PruffConnectBillingPortal = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [pagination, setPagination] = useState<Pagination>(BASE_PAGINATION);
  const dispatch = useDispatch();
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const [folio, setFolio] = useState<string>('');
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const generateQuery = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    let query = '';
    if (page) query += `page=${page}&pageSize=${pageSize}&`;
    if (folio) query += `folio=${folio}&`;
    if (startDate) query += `startDate=${startDate}&`;
    if (endDate) query += `endDate=${endDate}&`;
    return query;
  };

  const fetchInvoices = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    if (!user?.clientId) return;
    setLoading(true);
    try {
      const query = generateQuery({ page, pageSize });
      const invoicesResponse = await pruffConnectGetReceivedInvoices(
        dispatch,
        user?.clientId,
        query,
      );
      setInvoices(invoicesResponse.data);
      setPagination(invoicesResponse.pagination);
      setLoading(false);
      return invoicesResponse.data;
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    void fetchInvoices({ page: 1, pageSize: 10 });
  }, []);

  const filters: Filter[] = [
    {
      type: 'text',
      label: 'Folio',
      value: folio,
      setter: setFolio,
    },
    {
      type: 'date',
      label: 'Fecha de emisión',
      dateKey: 'startDate',
      value: startDate,
      setter: setStartDate,
    },
    {
      type: 'date',
      label: 'Fecha de emisión',
      dateKey: 'endDate',
      value: endDate,
      setter: setEndDate,
    },
  ];

  const buttons: CustomButtonProps[] = [
    {
      name: 'Buscar',
      color: 'primary',
      action: () => {},
      customButton: (
        <GlobalSearcher
          filters={filters}
          triggerSearch={() => fetchInvoices({ page: 1, pageSize: 10 })}
        />
      ),
    },
  ];

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      <HeaderWithActions
        variant="body1"
        title="Acá podrás ver los facturas que te hemos emitido."
        buttons={buttons}
      />
      <TableWithPagination
        data={invoices}
        setData={setInvoices}
        pagination={pagination}
        setPagination={setPagination}
        dataHeaders={[
          { key: 'folio', label: 'Folio' },
          { key: 'amount', label: 'Monto', type: 'money' },
          { key: 'issuedDate', label: 'Fecha de emisión', type: 'date' },
          { key: 'receiptDate', label: 'Fecha de recepción', type: 'date' },
        ]}
        // handleClickRow={handleDetails}
      />
    </div>
  );
};

export default PruffConnectBillingPortal;
